import type { Catalog, PlanChoice } from './types';

export const DEFAULT_CHOICE: PlanChoice = {
  plan: 'pro',
  cycle: 'annual',
  students: 300,
  addons: [],
};

/** Keeps a choice valid for its plan: allowed cycle and add-ons. */
export function normalizeChoice(catalog: Catalog, choice: PlanChoice): PlanChoice {
  const plan = catalog.plans.find((p) => p.key === choice.plan) ?? catalog.plans[0];
  const cycle = plan.cycles.includes(choice.cycle) ? choice.cycle : plan.cycles[0];
  const addons = choice.addons.filter((key) =>
    catalog.addons.some((a) => a.key === key && a.plans.includes(plan.key)),
  );
  return { plan: plan.key, cycle, students: Math.max(1, choice.students), addons };
}
